
<div class="account">
  <page-header title="Account" />

  <form @submit.prevent="updateAccount">
    <section class="account-info">
      <image-upload
        v-model="account.photoUrl"
        name="profile-image"
        label="Profile Image"
        height="110"
        width="110"
      />

      <div class="inputs">
        <text-input
          id="account-displayName"
          v-model.trim="account.displayName"
          label="Display Name"
          maxlength="30"
        />

        <text-input
          id="account-profileLink"
          v-model.trim="account.profileLink"
          type="url"
          maxlength="75"
          label="Profile Link (Instagram, Facebook, Etc.)"
        />

        <div class="button-row">
          <btn :loading="saving" type="submit">
            Save
          </btn>

          <template v-if="hasPasswordLogin">
            <btn v-if="!isEmployee" kind="secondary" @click="changeEmailOpen = true">
              Change Email
            </btn>

            <btn kind="secondary" @click="changePasswordOpen = true">
              Change Password
            </btn>
          </template>
        </div>
      </div>
    </section>
  </form>

  <div v-if="loggedInProvider" class="logged-in-context">
    <icon class="icon" name="check_circle" />
    <span>Signed in with {{ loggedInProvider }}</span>
  </div>

  <template v-if="hasBilling">
    <h4 class="secondary-font">
      Billing
    </h4>

    <template v-if="hasSubscription">
      <div>
        <btn
          kind="secondary"
          :loading="redirecting"
          loading-text="Redirecting"
          @click="manageSubscription"
        >
          Manage Subscription
        </btn>
      </div>

      <br />
    </template>

    <template v-if="hasCollectorsClubSubscription">
      <h6>Collectors Club Premium Member</h6>

      <div>
        <btn
          kind="secondary"
          :loading="redirecting"
          loading-text="Redirecting"
          @click="manageCollectorsClubSubscription"
        >
          Manage Collectors Club Subscription
        </btn>
      </div>

      <br />
    </template>

    <template v-if="hasStripeSubscription">
      <btn
        kind="secondary"
        :loading="applyingGiftCard"
        loading-text="Applying"
        @click="giftCardEntryOpen = true"
      >
        Apply Gift Card
      </btn>

      <br />
    </template>

    <br />
  </template>

  <h4 class="secondary-font">
    Display Settings
  </h4>

  <form v-if="loaded">
    <select-input
      v-model="account.locale"
      label="Currency"
      :options="currencyOptions"
      @input="updateLocale"
    />

    <checkbox
      v-model="account.enableFuzzinessSearch"
      label="Enable search history spell checker"
      @input="updateAccount"
    />

    <br />

    <checkbox
      v-model="account.hideSalesHistoryValue"
      label="Hide CL Value on Sales History"
      @input="updateAccount"
    />
  </form>

  <br />

  <notification-settings />

  <br />

  <h4 class="secondary-font">
    User ID
  </h4>

  <align>
    <span>{{ user.uid }}</span>

    <icon-button
      tooltip="Copy to clipboard"
      icon="content_copy"
      @click="copyUid"
    />
  </align>

  <div class="advanced">
    <h4 class="secondary-font">
      Advanced
    </h4>

    <div class="button-row">
      <btn v-if="!hasPasswordLogin" kind="secondary" @click="addEmailLoginOpen = true">
        Add Email Login
      </btn>

      <btn kind="secondary" @click="deleteAccount">
        Delete Account
      </btn>
    </div>
  </div>

  <br />

  <h4 class="secondary-font">
    Legal
  </h4>

  <external-link :href="tosLink">
    <span>Terms of Use</span>
  </external-link>

  <br />

  <external-link :href="privacyLink">
    <span>Privacy Policy</span>
  </external-link>

  <modal
    title="Change Email"
    :open="changeEmailOpen"
    @close="changeEmailOpen = false"
  >
    <p class="description">
      Enter a new email and save. This will update your login email and your billing email.
    </p>

    <form @submit.prevent="changeEmail">
      <text-input
        id="account-email"
        v-model.trim="email"
        type="email"
        label="Email"
        required
      />

      <div class="button-row">
        <btn :loading="changingEmail" type="submit">
          Save
        </btn>
        <btn kind="secondary" @click="changeEmailOpen = false">
          Cancel
        </btn>
      </div>
    </form>
  </modal>

  <modal
    title="Change Password"
    :open="changePasswordOpen"
    @close="changePasswordOpen = false"
  >
    <p class="description">
      Enter a new password below to update it and login.
    </p>

    <form @submit.prevent="changePassword">
      <password-input
        id="currentPassword"
        v-model="currentPassword"
        label="Current Password"
        required
      />

      <password-input
        id="newPassword"
        v-model="newPassword"
        label="New Password"
        required
      />

      <div class="button-row">
        <btn :loading="changingPassword" type="submit">
          Save
        </btn>
        <btn kind="secondary" @click="changePasswordOpen = false">
          Cancel
        </btn>
      </div>
    </form>
  </modal>

  <modal
    title="Add Email Login"
    :open="addEmailLoginOpen"
    @close="addEmailLoginOpen = false"
  >
    <p class="description">
      Add an email/password login to your existing account
    </p>

    <form @submit.prevent="addEmailLogin">
      <text-input
        v-model.trim="addEmailLoginEmail"
        type="email"
        label="Email"
        required
      />

      <password-input
        v-model="addEmailLoginPassword"
        label="Password"
        required
      />

      <div class="button-row">
        <btn :loading="addingEmailLogin" type="submit">
          Save
        </btn>
        <btn kind="secondary" @click="addEmailLoginOpen = false">
          Cancel
        </btn>
      </div>
    </form>
  </modal>

  <gift-card-entry
    :open="giftCardEntryOpen"
    @close="giftCardEntryOpen = false"
    @submit="applyGiftCard"
  />
</div>
